export default __webpack_public_path__ + "static/media/new.80beb6dc.svg";